import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';
import { Link, Redirect} from 'react-router-dom';
import Overlay from '../../Miscelania/Overlay';
import getLocale from '../../../i18n/getLocale';

class TrainingRevisionsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      training_id: '',
      verify_revision_opened: '',
      training_status: '',
      training_revisions_data: [],
    };

    this.redirectRevision = this.redirectRevision.bind(this);

    this.locale = getLocale();
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.training_revisions_data)){
      this.setState({
        training_revisions_data: newProps.training_revisions_data,
      });
    }
    if(typeof newProps.training_id !== 'undefined'){
      this.setState({
        training_id: newProps.training_id,
        verify_revision_opened: newProps.verify_revision_opened,
        training_status: newProps.training_status,
      });
    }
  }

  createRevision(value, event) {
    event.preventDefault();
    var datasave = {
      id: value,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/criar/revisao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = config.get('url') + '/treinamento/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          document.location = url;
        }
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  redirectRevision (url) {
    window.location.href = url;
  }
  
  render() {
    var self = this;
    var training_id_int = parseInt(self.state.training_id);
    var verify_revision_opened_int = parseInt(self.state.verify_revision_opened);
    var training_status = parseInt(self.state.training_status);
    return (
<div>
  <RequestApi ref={'request_api'} />
  <Overlay overlay={this.state.overlay} handleAlert={this.props.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <h3 className="page-title">{this.locale.Treinamentos.EditarTreinamento.tabRevisao.tituloRevisoes}</h3>
  <hr/>
  {(verify_revision_opened_int === 0 && training_status !== 4) ? 
      <div>
        <button onClick={this.createRevision.bind(this, training_id_int)} className='btn btn-lg btn-primary' alt={this.locale.Treinamentos.EditarTreinamento.tabRevisao.botaoCriarRevisao} title={this.locale.Treinamentos.EditarTreinamento.tabRevisao.botaoCriarRevisao}><i className="fa fa-fw fa-pencil"></i> {this.locale.Treinamentos.EditarTreinamento.tabRevisao.botaoCriarRevisao}</button>     
        <hr/>
      </div>  
    : ""
  }
  <hr/>
  {(self.state.training_revisions_data === null || typeof self.state.training_revisions_data === 'undefined') ?  <div><small><em>{this.locale.Treinamentos.EditarTreinamento.tabRevisao.nenhumaRevisaoParaEsteTreinamento}</em></small><hr/></div> 
  : 
  <div>
    <table className="table table-bordered table-stripped table-hover">
      <thead>
        <tr>
          <th className="col-md-9 text-center">{this.locale.Treinamentos.EditarTreinamento.tabRevisao.DataDeCriacao}</th>
          <th className="col-md-3 text-center">{this.locale.Treinamentos.EditarTreinamento.tabRevisao.Status}</th>
          <th className="col-md-3 text-center">{this.locale.Treinamentos.EditarTreinamento.tabRevisao.Acoes}</th>
        </tr>
      </thead>
      <tbody id="suppliers-certifications">
        {Object.keys(self.state.training_revisions_data).map(function(k) {
          return (
            <tr>
              <td className="text-center">{self.state.training_revisions_data[k].created_at}</td>
              <td className="text-center">{self.state.training_revisions_data[k].status_str}</td>
              <td className="text-center">
                {(self.state.training_revisions_data[k].id === training_id_int) ?  
                  ""
                  : 
                  <button className={'btn btn-info btn-sm'} onClick={() => { self.redirectRevision('/treinamento/editar/' + self.state.training_revisions_data[k].id); }}>
                    <i className="fa fa-fw fa-eye"></i>
                  </button>
                }         
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
    <hr/>
  </div>
  }
</div>
    );
  }
}

export default TrainingRevisionsTab;



// WEBPACK FOOTER //
// ./src/Components/Trainings/Elements/TrainingRevisionsTab.js